export default __webpack_public_path__ + "static/media/mpia.0b8fda81.png";